<div class="wrapper">
  <app-header></app-header>

  <div class="content-wrapper">
    <router-view></router-view>
  </div>

  <app-footer></app-footer>
</div>
